import { render, staticRenderFns } from "./AdminTemplateTable.vue?vue&type=template&id=9f822a90&"
import script from "./AdminTemplateTable.vue?vue&type=script&lang=ts&"
export * from "./AdminTemplateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports